/* eslint-disable import/no-anonymous-default-export */
import {
  SET_ACTION_ITEM,
  SET_DASHBOARD_DETAILS,
  SET_DEVICE,
  SET_NOTIFICATION_COUNT,
  SET_ROLE,
  RESET_DETAILS,
  SET_USER_ID,
  SET_NAVIGATION,
  SET_NOTIFICATION_MESSAGE,
  SET_ACTIVE_BADGE_COUNT,
  SET_COMPLETED_BADGE_COUNT,
  SET_FISCAL_YEAR,
  SET_FISCAL_YEAR_DATE
} from "./types";
import { getItem } from "app/utils/session";
import get from "lodash/get";
const userData = getItem("user_data") ? JSON.parse(getItem("user_data")) : "";
const roleId = get(userData, "roleId", 0);
const initialState = {
  roleId: 0,
  entity: roleId && (roleId === 3 || roleId === 4) ? "JOBS" : "",
  actionItem: roleId && (roleId === 3 || roleId === 4) ? "VIEW" : "HOME",
  navigation: { blockType: "", btnType: "", cylinderType: "", cylinderFlag: false },
  notificationCount: 0,
  device: {
    isMobile: false,
    isTablet: false,
    isDesktop: true,
  },
  notificationMessage: { type: "", message: "" },
  dashboard: {},
  userId: 0,
  badgeCount: { active: {}, completed: {} },
  fiscalYear: null,
  fiscalYearDate: { from: null, to: null }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FISCAL_YEAR:
      return { ...state, fiscalYear: action.payload };

    case SET_FISCAL_YEAR_DATE:
      return { ...state, fiscalYearDate: action.payload };

    case SET_ROLE:
      return { ...state, roleId: action.payload };

    case SET_NAVIGATION:
      return { ...state, navigation: action.payload };

    case SET_USER_ID:
      return { ...state, userId: action.payload };

    case SET_ACTION_ITEM:
      const { entity, actionItem } = action.payload;
      return { ...state, entity, actionItem };

    case SET_NOTIFICATION_COUNT:
      return { ...state, notificationCount: action.payload };

    case SET_DEVICE:
      return { ...state, device: action.payload };

    case SET_DASHBOARD_DETAILS:
      return { ...state, dashboard: action.payload };

    case SET_NOTIFICATION_MESSAGE:
      return { ...state, notificationMessage: action.payload };

    case SET_ACTIVE_BADGE_COUNT:
      return { ...state, badgeCount: { ...state.badgeCount, active: action.payload } };

    case SET_COMPLETED_BADGE_COUNT:
      return { ...state, badgeCount: { ...state.badgeCount, completed: action.payload } };

    case RESET_DETAILS:
      return { ...initialState };

    default:
      return { ...state };
  }
};
